export default "__VITE_ASSET__BUZ$o_Hi__"